/**
 * BEM (Block-Element-Modifier) class name generator
 *
 * @example
 * // Block only
 * bem('ui-button')
 * // → "ui-button"
 *
 * // Block with modifiers
 * bem('ui-button', { modifiers: { primary: true, md: true } })
 * // → "ui-button ui-button--primary ui-button--md"
 *
 * // Element only
 * bem('ui-button', { element: 'icon' })
 * // → "ui-button__icon"
 *
 * // Element with modifiers
 * bem('ui-button', { element: 'icon', modifiers: { large: true } })
 * // → "ui-button__icon ui-button__icon--large"
 *
 * // Falsy modifiers are excluded
 * bem('ui-button', { modifiers: { primary: true, disabled: false } })
 * // → "ui-button ui-button--primary"
 */

type Modifiers = Record<string, boolean | undefined>;

interface BemOptions {
  element?: string;
  modifiers?: Modifiers;
}

export function bem(block: string, options?: BemOptions): string {
  const base = options?.element ? `${block}__${options.element}` : block;

  if (!options?.modifiers) return base;

  const classes = [base];
  for (const [key, value] of Object.entries(options.modifiers)) {
    if (value) {
      classes.push(`${base}--${key}`);
    }
  }

  return classes.join(" ");
}
